module.exports = __webpack_public_path__ + "img/result_bg2.4b17857d.png";